<template>
  <option
    :value="deliveryOption.value"
    :data-label="deliveryOption.orderLabel"
  >
    {{ deliveryOption.label }} {{ labelPrice }}
  </option>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SelectOption',
  props: {
    deliveryOption: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'isFeeExempt'
    ]),
    labelPrice() {
      return this.shouldDisplayPrice
        ? this.i18n('price', { price: this.$n(this.deliveryOption.price, 'currency') })
        : '';
    },
    shouldDisplayPrice() {
      return this.hasFee && !this.isFeeExempt;
    },
    hasFee() {
      return this.deliveryOption.price > 0;
    }
  },
  methods: {
    i18n(key, values = null) {
      return this.$t(this.i18nPath(key), values);
    },
    i18nPath(key) {
      return `selectOption.${key}`;
    }
  }
};
</script>
